module.exports = __webpack_public_path__ + "img/no-tokens-found-80px.721cee4.svg";